import React from "react";
import {ChipsPopup} from "./ChipsPopup";
import {calc} from "../../../js/chips-common";

export function WatermelonImagePopup(props) {
    ChipsPopup(props,
        (
            <div style={{
                width: calc(280),
                borderRadius: `${calc(10)} ${calc(10)} 0 0`,
                overflow: 'hidden',
            }}>
                <img style={{width: '100%'}} src={props.image}/>
            </div>
        )
    )
}
